import React from 'react'
import { FormGroup, Label, Input, Row, Col } from 'reactstrap'
import { FORM_FIELD_WIDTHS } from '../constants'

interface FormFieldProps {
  label: string
  value: string
  readOnly?: boolean
  type?: string
  className?: string
}

interface FormRowProps {
  children: React.ReactNode
}

export const FormField: React.FC<FormFieldProps> = ({
  label,
  value,
  readOnly = false,
  type = 'text',
  className,
}) => (
  <FormGroup row>
    <Label sm={FORM_FIELD_WIDTHS.LABEL}>{label}</Label>
    <Label sm={FORM_FIELD_WIDTHS.FIELD}>
      <Input
        defaultValue={value}
        readOnly={readOnly}
        type={type}
        className={className}
      />
    </Label>
  </FormGroup>
)

export const FormRow: React.FC<FormRowProps> = ({ children }) => (
  <Row>
    <Col
      sm={{ size: FORM_FIELD_WIDTHS.FIELD, offset: FORM_FIELD_WIDTHS.LABEL }}
    >
      {children}
    </Col>
  </Row>
)
